import { j as o } from "./jsx-runtime-3tyXYecC.mjs";
import { C as t } from "./calendar-base-D7AWCGXE.mjs";
import { m as d } from "./tss-DN0acMKN.mjs";
const l = d()(({ borderRadiuses: e, constructs: a, mixins: r }) => ({
  root: {
    border: `1px solid ${a.border.neutral.xWeak}`,
    borderRadius: e[400],
    boxShadow: `${r.boxShadow("300", a.surface.neutral.xxStrong)}`,
    width: "fit-content"
  }
}));
function m({ biId: e, id: a, month: r, monthsToShow: n = 1, renderDay: s }) {
  const { classes: i } = l();
  return /* @__PURE__ */ o.jsx("div", { className: i.root, id: a, children: /* @__PURE__ */ o.jsx(
    t,
    {
      biId: e,
      "data-fabric-component": "CalendarView",
      month: r,
      monthsToShow: n,
      navigation: "none",
      renderDay: s
    }
  ) });
}
m.Day = t.Day;
export {
  m as C
};
//# sourceMappingURL=calendar-view--P--cqeC.mjs.map
